import { render } from "./IControl.vue?vue&type=template&id=7fdcd024"
import script from "./IControl.vue?vue&type=script&lang=js"
export * from "./IControl.vue?vue&type=script&lang=js"
script.render = render

export default script